module.exports = __webpack_public_path__ + "static/media/Scale Lateral_Z1 Z2.cb0c0590.png";